import { hasExtension } from './hasExtension';

const compareFiles = (first: File, second: File): boolean =>
    first.name === second.name &&
    first.size === second.size &&
    first.lastModified === second.lastModified &&
    first.type === second.type;

/**
 * @deprecated Use `useVerifyFileUpload` hook instead as it uses the i18n translations for errors.
 */
const verifyFileUpload = (
    files: File[],
    alreadyRequestedFiles?: string[],
): { files: File[]; warnings: { [error: string]: string } } => {
    const verifiedFiles: File[] = [];
    let warnings: { [error: string]: string } = {};
    const FILE_SIZE_LIMIT_FRIENDLY = GLOBAL_ATTACHMENT_FILESIZE_LIMIT / 1000 ** 2;

    files.forEach((file: File) => {
        if (!hasExtension(file.name)) {
            warnings = {
                ...warnings,
                'no-fileExtension': 'Cannot upload a file without an extension.',
            };

            return;
        }

        if (file.size === 0) {
            warnings = {
                ...warnings,
                'no-zero-bytes': 'Cannot upload an empty file.',
            };

            return;
        }

        if (file.size >= GLOBAL_ATTACHMENT_FILESIZE_LIMIT) {
            warnings = {
                ...warnings,
                // eslint-disable-next-line max-len
                'file-size-limit': `The file ${file.name} is too large. Please upload a file smaller than ${FILE_SIZE_LIMIT_FRIENDLY} MB.`,
            };

            return;
        }

        // eslint-disable-next-line no-unused-expressions
        !verifiedFiles.some((current: File) => compareFiles(file, current))
            ? verifiedFiles.push(file)
            : (warnings = {
                  ...warnings,
                  'no-duplicate-files': 'Cannot upload duplicate files.',
              });

        // if included already requested files, validate if there is not another file with the same name:
        if (alreadyRequestedFiles && alreadyRequestedFiles.length > 0) {
            if (alreadyRequestedFiles.includes(file.name)) {
                warnings = {
                    ...warnings,
                    'repeated-file-name': 'Another file with the same name is already attached',
                };
            }
        }
    });

    return {
        files: verifiedFiles,
        warnings,
    };
};

export default verifyFileUpload;
